import React, { useEffect, useRef, useState } from 'react';
import './HomePage.scss';
import LayoutHome from '../../components/Layout/LayoutHome';
import TabProduct from '../../components/Tabmenu/TabProduct';
import ContactForm from '../../components/Form/ContactForm';
import mainPhone from '../../assets/images/img_phone@3x.png';
import mainBg from '../../assets/images/bg-effect@2x.png';
import appStoreIcon from '../../assets/images/img_app_store_iOS@2x.png';
import googlePlayIcon from '../../assets/images/img_google_play@2x.png';
import packageTextData from '../../_constants/packageTextData';
import useCheckupCardStore from '../../_store/useCheckupCardStore';
import useWindowSizeStore from '../../_store/useWindowSizeStore';
import useUiStateStore from '../../_store/useUiStateStore';

const HomePage = () => {
    const packageRef = useRef(null);
    const productRef = useRef(null);
    const contactRef = useRef(null);
    const cardUlRef_mo = useRef();
    const liElementsRef = useRef([]);
    const titleBedgeRef = useRef();
    const [activeIndex, setActiveIndex] = useState(0);
    const { windowMode } = useWindowSizeStore();
    const { checkupCardItems, setCardDisable } = useCheckupCardStore();
    const { setRegistPopupOpen, isRegistPopupOpen } = useUiStateStore();
    const [selectedCardItem, setSelectedCardItem] = useState (
        {
            item: {
                cardName: "",
                imgClassName: "",
                isEnable: true,
                desc: ""
            },
            idx: null,
            isPopupOpen: false
        }
    );

    useEffect(() => {
        const liElements = cardUlRef_mo.current.querySelectorAll('li');
        liElementsRef.current = liElements;

        badgeAreaAnimation();
        setCardDisable(windowMode === 'mo' ? "Light" : "All");
    }, []);
    
    const moveToPackage = () => {
        if (packageRef.current) {
            window.scrollTo({
                top: packageRef.current.offsetTop - 52,
                behavior: 'smooth'
            });
        }
    }

    const moveToProduct = () => {
        if (productRef.current) {
            window.scrollTo({
                top: productRef.current.offsetTop - 52,
                behavior: 'smooth'
            });
        }
    }

    const moveToContact = () => {
        if (contactRef.current) {
            window.scrollTo({
                top: contactRef.current.offsetTop - 52,
                behavior: 'smooth'
            });
        }
    };

    // 검사 card 클릭
    const checkupCardClick = (item, idx) => {
        setSelectedCardItem (
            {
                item: item,
                idx: idx,
                isPopupOpen: true
            }
        );
    };

    const packageTabClick = (idx, packageName) => {
        setActiveIndex(idx);
        setCardDisable(packageName);
        badgeAreaAnimation();
    };

    // 패키지 설명 UI 애니메이션
    const badgeAreaAnimation = () => {
        const container = titleBedgeRef.current;
        if (container) {
            const em = container.querySelector('em');
            const span = container.querySelector('span');

            em.style.display = 'none';
            span.style.display = 'none';
            em?.classList.remove('animate');
            span?.classList.remove('animate');

            setTimeout(() => {    
                em.style.display = 'block';
                span.style.display = 'block';
              
                void em.offsetWidth;
                void span.offsetWidth;

                em?.classList.add('animate');
                span?.classList.add('animate');
            }, 100);
        }
    }

    const registFreeVoucherClick = (e) => {
        if(isRegistPopupOpen) return;
        setRegistPopupOpen(true);
    };

    const goAppStoreBtnClick = () => {
        window.open('https://apps.apple.com/kr/app/hello-헬스케어여기로/id6744082773', '_blank');
    };

    const goGooglePlayStoreBtnClick = () => {
        window.open('https://play.google.com/store/apps/details?id=kr.co.saluscare.hello&pcampaignid=web_share', '_blank');
    };

    return (
        <>
            <LayoutHome
                moveToPackage={moveToPackage}
                moveToProduct={moveToProduct}
                moveToContact={moveToContact}
                selectedCardItem={selectedCardItem}
            >
                <div className="top-banner-area">
                    <div className="top-banner-box">
                        <div className='top-banner-left-wrapper'>
                            <div className="top-banner-txt">
                                <div className="top-banner-title">
                                    <strong className="tit">일상을 건강하게<br className='br'/>헬로와 함께해요</strong>
                                    <p className="desc">언제든, 어디서든 당신이 편한 곳에서<br className='br'/>건강 수준을 파악하고 관리해보세요.</p>
                                </div>
                            </div>

                            <div className='top-banner-btn'>
                                <div className='goto-app-store-btn-wrapper'>
                                    <button type="button" className="btn-black" onClick={() => goAppStoreBtnClick()}>
                                        <img src={appStoreIcon} alt="" className='store-icon'/>
                                        <span className="inquireMessage">App Store</span>
                                    </button>

                                    <button type="button" className="btn-black" onClick={() => goGooglePlayStoreBtnClick()}>
                                        <img src={googlePlayIcon} alt="" className='store-icon'/>
                                        <span className="inquireMessage">Google Play</span>
                                    </button>
                                </div>
                                <div className="btn-container">
                                    <button type="button" className="btn-basic" onClick={(e) => registFreeVoucherClick(e)}>
                                        <span className="inquireMessage">
                                            이용권 신청하기
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <div className="top-banner-img">
                            <div className='bg-wrapper'>
                                <img src={mainBg} alt="background" className="bg" />
                            </div>
                            <img src={mainPhone} alt="foreground" className="fg" />
                        </div>
                    </div>
                </div>

                {/* PACKAGE - PC */}
                <div ref={packageRef} className="contents-area pc" id="package">
                    <div className="contents-container">
                        <div className="contents-section">
                            <div className="contents-section-title">
                                <strong>PACKAGE</strong>
                            </div>
                            <ul className="card-list-area">
                                <li>
                                    <span className="num">01</span>
                                    <div className="title-area">
                                        <strong className="title"><em className="underline"></em>헬로 Light</strong>
                                        <span className="tag">7일</span>
                                    </div>
                                    <p className="desc">휴대폰만으로 간편하게 검사를 진행할 수 있어요.</p>
                                    <ul className="gray-badge-area">
                                        <li>수면</li>
                                        <li>근골격계</li>
                                        <li>인지기능</li>
                                        <li>스트레스</li>
                                        <li>전립선 건강</li>
                                        <li>월경 전 증후군</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="num">02</span>
                                    <div className="title-area">
                                        <strong className="title"><em className="underline p2"></em>헬로 Wave</strong>
                                        <span className="tag blue">14일</span>
                                    </div>
                                    <p className="desc">집에서도 손가락 채혈 없이 혈당을 확인할 수 있어요.</p>
                                    <ul className="gray-badge-area">
                                        <li>수면</li>
                                        <li>근골격계</li>
                                        <li>인지기능</li>
                                        <li>스트레스</li>
                                        <li>전립선 건강</li>
                                        <li>월경 전 증후군</li>
                                        <li>CGM(연속혈당)</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="num">03</span>
                                    <div className="title-area">
                                        <strong className="title"><em className="underline p3"></em>헬로 Bounce</strong>
                                        <span className="tag blue">7일</span>
                                    </div>
                                    <p className="desc">일상 속 나의 수면부터 걷기까지의 건강을 모니터링 할 수 있어요.</p>
                                    <ul className="gray-badge-area">
                                        <li>수면</li>
                                        <li>근골격계</li>
                                        <li>인지기능</li>
                                        <li>스트레스</li>
                                        <li>전립선 건강</li>
                                        <li>월경 전 증후군</li>
                                        <li>심전도</li>
                                        <li>보행 분석</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="num">04</span>
                                    <div className="title-area">
                                        <strong className="title"><em className="underline p4"></em>헬로 Premium</strong>
                                        <span className="tag blue">14일</span>
                                    </div>
                                    <p className="desc">
                                        헬로에서 제공하는 모든 검사가 포함되어 있어요. <br/>
                                        일상에서 손쉽게 건강을 확인하세요!
                                    </p>
                                    <ul className="gray-badge-area">
                                        <li>수면</li>
                                        <li>근골격계</li>
                                        <li>인지기능</li>
                                        <li>스트레스</li>
                                        <li>전립선 건강</li>
                                        <li>월경 전 증후군</li>
                                        <li>심전도</li>
                                        <li>보행 분석</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* PRODUCT - PC */}
                <div ref={productRef} className="contents-area pc" id="product">
                    <div className="contents-container">
                        <div className="contents-section center">
                            <div className="contents-section-title">
                                <strong className="fc-white">PRODUCT</strong>
                            </div>
                            <TabProduct />
                        </div>
                    </div>
                </div>

                {/* PRODUCT - MO */}
                <div className="contents-area mo" id="product">
                    <div className="contents-container">
                        <div className="contents-section center">
                            <div className="product-tab-menu">
                                <ul className="product-tab-menu-list">
                                    {packageTextData.map((item, idx) => (
                                        <li
                                            key={idx}
                                            className={activeIndex === idx ? 'active' : ''}
                                            onClick={() => packageTabClick(idx, item.packageName)}
                                        >
                                            <span>{item.packageName}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="item-list-container">
                                <div className="contents-section-title">
                                    <strong className="fc-blue">PACKAGE</strong>
                                    <div className="title-badge-area" ref={titleBedgeRef}> 
                                        <em className="tit moveRight">헬로 {packageTextData[activeIndex].packageName}</em>
                                        <span className="badge moveLeft">{packageTextData[activeIndex].packageDay}일</span>
                                    </div>
                                    <p className="desc-area">
                                        {packageTextData[activeIndex].packageExplan.split('<br/>').map((line, idx) => (
                                            <React.Fragment key={idx}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </p>
                                </div>
                            </div>

                            <div className="item-list-container">
                                <ul className="item-list" ref={cardUlRef_mo}>
                                    {checkupCardItems.map((item, idx) => (
                                        <li
                                            key={idx}
                                            className={item.isEnable ? '' : 'disabled'}
                                            onClick={() => checkupCardClick(item, idx)}
                                        >
                                            <div>
                                                <span className={`ico ${item.imgClassName}`}></span>
                                                <strong>
                                                    {item.cardName.split('<br/>').map((line, idx) => (
                                                        <React.Fragment key={idx}>
                                                            {line}
                                                            <br/>
                                                        </React.Fragment>
                                                    ))}
                                                </strong>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <p className="notice">
                                카드를 클릭 하시면 상세정보를 확인할 수 있습니다.
                            </p>
                        </div>
                    </div>
                </div>

                {/* CONTACT */}
                <ContactForm ref={contactRef} />
            </LayoutHome>
        </>
    )
}

export default HomePage;
